import { render, staticRenderFns } from "./u-swiper-pagination-line.vue?vue&type=template&id=8af1a13a&scoped=true&"
import script from "./u-swiper-pagination-line.vue?vue&type=script&lang=js&"
export * from "./u-swiper-pagination-line.vue?vue&type=script&lang=js&"
import style0 from "./u-swiper-pagination-line.vue?vue&type=style&index=0&id=8af1a13a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af1a13a",
  null
  
)

export default component.exports